module.exports = __webpack_public_path__ + "img/notepad.ebffdf70.svg";